var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8519 3.83248C15.8519 3.99549 15.8519 4.12589 15.8519 4.28889C15.8519 8.82039 12.4288 14.0039 6.1369 14.0039C4.18086 14.0039 2.38782 13.4497 0.888184 12.4717C1.14899 12.5043 1.4098 12.5369 1.7032 12.5369C3.30064 12.5369 4.76767 11.9827 5.94129 11.0698C4.44166 11.0372 3.17023 10.0592 2.74642 8.68999C2.97463 8.72259 3.17023 8.75519 3.39844 8.75519C3.69185 8.75519 4.01785 8.68999 4.27866 8.62479C2.71382 8.29878 1.5402 6.92955 1.5402 5.26691V5.23431C1.99661 5.49512 2.55082 5.62552 3.10503 5.65812C2.15961 5.03871 1.5728 3.99549 1.5728 2.82186C1.5728 2.16985 1.7358 1.58303 2.02921 1.09402C3.72445 3.14787 6.2673 4.5171 9.10356 4.6801C9.03836 4.4193 9.00576 4.15849 9.00576 3.89768C9.00576 2.00684 10.538 0.474609 12.4288 0.474609C13.4069 0.474609 14.2871 0.865818 14.9391 1.55043C15.6889 1.38743 16.4387 1.09402 17.0907 0.702814C16.8299 1.51783 16.3083 2.16985 15.5911 2.59366C16.2757 2.52845 16.9603 2.33285 17.5471 2.07204C17.0907 2.75666 16.5039 3.34347 15.8519 3.83248Z",
    fill: "#DEE965"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8c475648998169de49fbc167007e5123.svg";
export { ForwardRef as ReactComponent };